import * as React from 'react';

const PlusSprite = (props) => (
    <svg
        {...props}
        fill='none'
        height={16}
        viewBox='0 0 36 16'
        width={36}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M8.625 2h-1.25v5.375H2v1.25h5.375V14h1.25V8.625H14v-1.25H8.625zM28.625 2h-1.25v5.375H22v1.25h5.375V14h1.25V8.625H34v-1.25h-5.375z'
            fill='currentColor' />
    </svg>
);

export default PlusSprite;
